import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { orange } from '@mui/material/colors';
import IconButton from '@mui/material/IconButton';

export const DropdownFavoriteOptionIcon = ({ option, favoriteOptions, setOptionsAsFavorite }) => {
  return (
    <IconButton
      size="small"
      onClick={event => {
        event.stopPropagation();
        setOptionsAsFavorite(option);
      }}
      sx={{ padding: 0, marginTop: '-3px' }}
    >
      {favoriteOptions?.includes(option.id) ? (
        <StarIcon sx={{ color: orange[400] }} />
      ) : (
        <StarOutlineIcon sx={{ color: orange[400] }} />
      )}
    </IconButton>
  );
};
